import { useContext } from 'react';
import { VideoModalContext } from '../context/VideoModalContext';

export const useVideoModal = () => {
  const context = useContext(VideoModalContext);

  if (!context) {
    throw new Error('useVideoModal must be used within a VideoModalProvider');
  }

  return context;
};
